import React, { lazy } from 'react';
interface BonusCardProps {
  title: string;
  description: string;
  imageSrc: string;
  bonusNumber: number;
  value?: number;
}
export function BonusCard({
  title,
  description,
  imageSrc,
  bonusNumber,
  value = 15
}: BonusCardProps) {
  return <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100 hover:shadow-lg transition-all duration-300 flex flex-col h-full" data-id="element-161">
      {/* Fixed aspect-ratio container prevents layout shift while
              the lazy-loaded image decodes — keeps scroll anchors stable. */}
      <div className="relative bg-gray-50 aspect-square flex items-center justify-center overflow-hidden" data-id="element-162">
        <div className="absolute top-0 right-0 bg-red-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg shadow-sm z-10" data-id="element-163">
          OFFERT AUJOURD'HUI
        </div>
        <div className="absolute top-0 left-0 bg-blue-900 text-white text-xs font-bold px-3 py-1 rounded-br-lg shadow-sm z-10" data-id="element-164">
          OFFERT #{bonusNumber}
        </div>
        <img src={imageSrc} alt={`Offert ${bonusNumber}: ${title}`} width={400} height={400} className="w-3/4 h-3/4 object-contain transform hover:scale-105 transition-transform duration-300" loading="lazy" decoding="async" data-id="element-165" />
      </div>

      <div className="p-5 flex flex-col flex-grow text-center" data-id="element-166">
        <h3 className="text-lg font-bold text-gray-900 mb-2 leading-tight" data-id="element-167">
          {title}
        </h3>
        <p className="text-gray-600 text-sm flex-grow" data-id="element-168">{description}</p>
        <div className="mt-4 pt-4 border-t border-gray-100" data-id="element-169">
          <span className="text-blue-900 font-bold text-sm uppercase tracking-wide" data-id="element-170">
            Valeur :{' '}
            <span className="line-through text-gray-400" data-id="element-171">{value} €</span>{' '}
            <span className="text-red-500" data-id="element-172">OFFERT</span>
          </span>
        </div>
      </div>
    </div>;
}